<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="110px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="所属接口">
<!--                  <el-input style="width: 177px" v-model="queryForm.apiId"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择接口" labelName="apiName"
                               labelValue="apiId" :value="queryForm.apiId" :limit='1' size='small' placeholder='请选择'
                               @getValue="getSeachUser1" :columns="SMSAPI_code" :searchs="SMSAPI_search" dataListUrl="/biz/apismsapi/findList" entityBeanName="apiSmsApi" queryEntityUrl="/biz/apismsapi/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="用户">
<!--                  <el-input style="width: 177px" v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择用户" labelName="userName"
                               labelValue="userId" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSeachUser" :columns="TEMPLATEUSER_code" :searchs="TEMPLATEUSER_search" dataListUrl="/biz/apiuser/findList" entityBeanName="apiUser" queryEntityUrl="/biz/apiuser/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="短信类型">
<!--                  <el-input  v-model="queryForm.smsType"></el-input>-->
                  <el-select clearable style="width: 177px" size="small" v-model="queryForm.smsType" placeholder="请选择">
                      <el-option label="商务" :value="1"></el-option>
                      <el-option label="接口" :value="2"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="发送类型">
<!--                  <el-input  v-model="queryForm.sendType"></el-input>-->
                  <el-select clearable style="width: 177px" size="small" v-model="queryForm.sendType" placeholder="请选择">
                      <el-option label="即时发送" :value="1"></el-option>
                      <el-option label="等待审核后发送" :value="2"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="审核状态">
<!--                  <el-input  v-model="queryForm.status"></el-input>-->
                  <el-select clearable style="width: 177px" size="small" v-model="queryForm.status" placeholder="请选择">
                      <el-option label="审核中" :value="1"></el-option>
                      <el-option label="审核成功" :value="2"></el-option>
                      <el-option label="审核失败" :value="3"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="用户接口账号">
                  <el-input  v-model="queryForm.accountUser"></el-input>
              </el-form-item>
              <el-form-item label="接口类型">
<!--                  <el-input  v-model="queryForm.smsApiType"></el-input>-->
                  <el-select clearable style="width: 177px" size="small" v-model="queryForm.smsApiType" placeholder="请选择">
                      <el-option label="验证码" :value="1"></el-option>
                      <el-option label="通知" :value="2"></el-option>
                      <el-option label="广告" :value="3"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getApiSmsApiaccountList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addApiSmsApiaccount"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editApiSmsApiaccount(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteApiSmsApiaccount(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshApiSmsApiaccountList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="apiSmsApiaccountList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="apiId"
        label="所属接口"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.apiId && scope.row.templateApi">
                  <div style="text-align: left">接口名称:{{scope.row.templateApi.apiName}}</div>
                  <div style="text-align: left">接口状态:{{scope.row.templateApi.apiUrl}}</div>
                  <div style="text-align: left">默认接口:{{scope.row.templateApi.defaultType == 0 ? '默认接口' : '非默认接口'}}</div>
                  <div style="text-align: left">调用方法:{{scope.row.templateApi.apiMethod}}</div>
                  <div style="text-align: left">内容编码:{{scope.row.templateApi.smsCode}}</div>
              </div>
              <span v-else>--</span>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.userId && scope.row.templateUser">
                  <div style="text-align: left">用户账号:{{scope.row.templateUser.userName}}</div>
                  <div style="text-align: left">用户号码:{{scope.row.templateUser.userMobile}}</div>
                  <div style="text-align: left">用户状态:{{scope.row.templateUser.userStatus == 0 ? '正常' : '冻结'}}</div>
              </div>
              <span v-else>--</span>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="smsSign"
        label="短信签名"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="smsType"
        label="短信类型"
        width="180"
      >
          <template slot-scope="scope">
              {{scope.row.smsType == 1 ? '商务' : '接口'}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sendType"
        label="发送类型"
        width="180"
      >
          <template slot-scope="scope">
              {{scope.row.sendType == 1 ? '即时发送' : '等待审核后发送'}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="accountAddtimeFormatter"
        label="接口账号添加时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="status"
        label="审核状态"
        width="180"
      >
          <template slot-scope="scope">
              {{scope.row.status == 1 ? '审核中' : scope.row.status == 2 ? '审核成功' : '审核失败'}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="failReason"
        label="审核失败原因"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="accountUser"
        label="用户接口账号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="accountPwd"
        label="用户接口密码"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="smsApiType"
        label="接口类型"
        width="180"
      >
          <template slot-scope="scope">
              {{scope.row.smsApiType == 1 ? '验证码' : scope.row.smsApiType == 2 ? '通知' : '广告'}}
          </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkApiSmsApiaccount(scop.row.accountId)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editApiSmsApiaccount(scop.row.accountId)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteApiSmsApiaccount(scop.row.accountId)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="apiSmsApiaccountStates[apiSmsApiaccountState]"
      :visible.sync="showDialog"
      width="60%"
      :append-to-body="true"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="apiSmsApiaccount"
          ref="apiSmsApiaccountForm"
          :rules="rules"
          label-width="110px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="所属接口"
            prop="apiId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px"-->
<!--              v-model="apiSmsApiaccount.apiId"-->
<!--              :disabled="apiSmsApiaccountState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择接口" labelName="apiName" :disabled="apiSmsApiaccountState == 'check'"
                           labelValue="apiId" :value="apiSmsApiaccount.apiId" :limit='1' size='small' placeholder='请选择'
                           @getValue="getUser1" :columns="SMSAPI_code" :searchs="SMSAPI_search" dataListUrl="/biz/apismsapi/findList" entityBeanName="apiSmsApi" queryEntityUrl="/biz/apismsapi/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px"-->
<!--              v-model="apiSmsApiaccount.userId"-->
<!--              :disabled="apiSmsApiaccountState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择用户" labelName="userName" :disabled="apiSmsApiaccountState == 'check'"
                           labelValue="userId" :value="apiSmsApiaccount.userId" :limit='1' size='small' placeholder='请选择用户'
                           @getValue="getUser" :columns="TEMPLATEUSER_code" :searchs="TEMPLATEUSER_search" dataListUrl="/biz/apiuser/findList" entityBeanName="apiUser" queryEntityUrl="/biz/apiuser/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="短信签名"
            prop="smsSign"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiSmsApiaccount.smsSign"
              :disabled="apiSmsApiaccountState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="短信类型"
            prop="smsType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="apiSmsApiaccount.smsType"-->
<!--              :disabled="apiSmsApiaccountState == 'check'"-->
<!--            ></el-input>-->
              <el-select style="width: 177px" clearable size="small" v-model="apiSmsApiaccount.smsType" placeholder="请选择" :disabled="apiSmsApiaccountState == 'check'">
                <el-option label="商务" :value="1"></el-option>
                <el-option label="接口" :value="2"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="发送类型"
            prop="sendType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="apiSmsApiaccount.sendType"-->
<!--              :disabled="apiSmsApiaccountState == 'check'"-->
<!--            ></el-input>-->
              <el-select style="width: 177px" clearable size="small" v-model="apiSmsApiaccount.sendType" placeholder="请选择" :disabled="apiSmsApiaccountState == 'check'">
                <el-option label="即时发送" :value="1"></el-option>
                <el-option label="等待审核后发送" :value="2"></el-option>
              </el-select>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="接口账号添加时间"-->
<!--            prop="accountAddtime"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px"-->
<!--              v-model="apiSmsApiaccount.accountAddtime"-->
<!--              :disabled="apiSmsApiaccountState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="审核状态"
            prop="status"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="apiSmsApiaccount.status"-->
<!--              :disabled="apiSmsApiaccountState == 'check'"-->
<!--            ></el-input>-->
              <el-select style="width: 177px" clearable size="small" v-model="apiSmsApiaccount.status" placeholder="请选择" :disabled="apiSmsApiaccountState == 'check'">
                <el-option label="审核中" :value="1"></el-option>
                <el-option label="审核成功" :value="2"></el-option>
                <el-option label="审核失败" :value="3"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="审核失败原因"
            prop="failReason"
            v-if="apiSmsApiaccount.status == 3"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiSmsApiaccount.failReason"
              :disabled="apiSmsApiaccountState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="用户接口账号"
            prop="accountUser"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiSmsApiaccount.accountUser"
              :disabled="apiSmsApiaccountState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="用户接口密码"
            prop="accountPwd"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="apiSmsApiaccount.accountPwd"
              :disabled="apiSmsApiaccountState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="接口类型"
            prop="smsApiType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="apiSmsApiaccount.smsApiType"-->
<!--              :disabled="apiSmsApiaccountState == 'check'"-->
<!--            ></el-input>-->
              <el-select style="width: 177px" clearable size="small" v-model="apiSmsApiaccount.smsApiType" placeholder="请选择" :disabled="apiSmsApiaccountState == 'check'">
                <el-option label="验证码" :value="1"></el-option>
                <el-option label="通知" :value="2"></el-option>
                <el-option label="广告" :value="3"></el-option>
              </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="apiSmsApiaccountState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { TEMPLATEUSER, TEMPLATEUSER_SEARCH, SMSAPI_SEARCH, SMSAPI } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetApiSmsApiaccountList();
                    this.getApiSmsApiaccountList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetApiSmsApiaccountList();
                    this.getApiSmsApiaccountList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     apiId: '', //接口id
                     userId: '', //用户id
                     smsSign: '', //短信签名
                     smsType: '', //短信类型：1：商务；2：接口
                     sendType: '', //发送类型：1：即时发送；2：等待审核后发送
                     accountAddtime: '', //接口账号添加时间
                     status: '', //审核状态：1：审核中；2：审核成功；3：审核失败
                     failReason: '', //审核失败原因
                     accountUser: '', //用户接口账号
                     accountPwd: '', //用户接口密码
                     smsApiType: '', //1:验证码 2:通知 3:广告
                },
                TEMPLATEUSER_code: TEMPLATEUSER,
                TEMPLATEUSER_search: TEMPLATEUSER_SEARCH,
                SMSAPI_code: SMSAPI,
                SMSAPI_search: SMSAPI_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                apiSmsApiaccountState: 'add',
                apiSmsApiaccountStates: {
                    add: '新建签名管理',
                    check: '查看签名管理',
                    edit: '修改签名管理'
                },

                multipleSelection: [],
                apiSmsApiaccountList: [],
                apiSmsApiaccount: {
                    accountId: '',
                    apiId: '', //接口id
                    userId: '', //用户id
                    smsSign: '', //短信签名
                    smsType: 2, //短信类型：1：商务；2：接口
                    sendType: 1, //发送类型：1：即时发送；2：等待审核后发送
                    accountAddtime: '', //接口账号添加时间
                    status: '', //审核状态：1：审核中；2：审核成功；3：审核失败
                    failReason: '', //审核失败原因
                    accountUser: '', //用户接口账号
                    accountPwd: '', //用户接口密码
                    smsApiType: 1, //1:验证码 2:通知 3:广告
                },
                btnLoading: false,

                rules: {
                    apiId: [{ required: true, message: '接口id不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户id不能为空', trigger: 'blur' }],
                    smsSign: [{ required: true, message: '短信签名不能为空', trigger: 'blur' }],
                    smsType: [{ required: true, message: '短信类型不能为空', trigger: 'blur' }],
                    sendType: [{ required: true, message: '发送类型不能为空', trigger: 'blur' }],
                    accountAddtime: [{ required: true, message: '接口账号添加时间不能为空', trigger: 'blur' }],
                    status: [{ required: true, message: '审核状态不能为空', trigger: 'blur' }],
                    failReason: [{ required: true, message: '审核失败原因不能为空', trigger: 'blur' }],
                    accountUser: [{ required: true, message: '用户接口账号不能为空', trigger: 'blur' }],
                    accountPwd: [{ required: true, message: '用户接口密码不能为空', trigger: 'blur' }],
                    smsApiType: [{ required: true, message: '接口类型不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            // this.getApiSmsApiaccountList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            init(){
                this.getApiSmsApiaccountList();
            },
            getUser(value){
                console.log(value)
                this.apiSmsApiaccount.userId = value
            },
            getSeachUser(value){
                this.queryForm.userId = value
            },
            getUser1(value){
                this.apiSmsApiaccount.apiId = value
            },
            getSeachUser1(value){
                this.queryForm.apiId = value
            },
            resetApiSmsApiaccountList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.apiSmsApiaccountList = [];
            },
            resetDialog() {
                this.apiSmsApiaccountState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      apiId: '', //接口id
                      userId: '', //用户id
                      smsSign: '', //短信签名
                      smsType: '', //短信类型：1：商务；2：接口
                      sendType: '', //发送类型：1：即时发送；2：等待审核后发送
                      accountAddtime: '', //接口账号添加时间
                      status: '', //审核状态：1：审核中；2：审核成功；3：审核失败
                      failReason: '', //审核失败原因
                      accountUser: '', //用户接口账号
                      accountPwd: '', //用户接口密码
                      smsApiType: '', //1:验证码 2:通知 3:广告
                };
                this.getApiSmsApiaccountList();
            },
            closeDialog() {
                this.showDialog = false
                this.apiSmsApiaccount = {
                      accountId: '',
                      apiId: '', //接口id
                      userId: '', //用户id
                      smsSign: '', //短信签名
                      smsType: 2, //短信类型：1：商务；2：接口
                      sendType: 1, //发送类型：1：即时发送；2：等待审核后发送
                      accountAddtime: '', //接口账号添加时间
                      status: '', //审核状态：1：审核中；2：审核成功；3：审核失败
                      failReason: '', //审核失败原因
                      accountUser: '', //用户接口账号
                      accountPwd: '', //用户接口密码
                      smsApiType: 1, //1:验证码 2:通知 3:广告
                };
            },
            submitForm() {
                if (this.apiSmsApiaccountState == 'add') {
                    this.$refs.apiSmsApiaccountForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/biz/apismsapiaccount/add`,{ ...this.apiSmsApiaccount }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetApiSmsApiaccountList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.apiSmsApiaccountState == 'edit') {
                    this.$refs.apiSmsApiaccountForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.apiSmsApiaccount.templateApi;
                            delete this.apiSmsApiaccount.templateUser;
                            post(`/biz/apismsapiaccount/edit`,{ ...this.apiSmsApiaccount }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetApiSmsApiaccountList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addApiSmsApiaccount() {
                this.showDialog = true;
                this.apiSmsApiaccountState = 'add';
            },
            checkApiSmsApiaccount(apiSmsApiaccountId) {
                console.log(apiSmsApiaccountId);
                this.currentApiSmsApiaccountId = apiSmsApiaccountId;

                this.getApiSmsApiaccountById();
                this.showDialog = true;
                this.apiSmsApiaccountState = 'check';
            },
            editApiSmsApiaccount(apiSmsApiaccountId) {
                console.log('apiSmsApiaccount', apiSmsApiaccountId);
                if (apiSmsApiaccountId) {
                    this.currentApiSmsApiaccountId = apiSmsApiaccountId;
                    this.getApiSmsApiaccountById();
                } else {
                    this.apiSmsApiaccount = { ...this.apiSmsApiaccount, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.apiSmsApiaccountState = 'edit';
            },
            deleteApiSmsApiaccount(apiSmsApiaccountId) {
                let ids = '';
                if (apiSmsApiaccountId) {
                    ids = apiSmsApiaccountId;
                } else {
                    ids = this.multipleSelection.map((apiSmsApiaccount) => apiSmsApiaccount.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/biz/apismsapiaccount/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetApiSmsApiaccountList();
                                this.getApiSmsApiaccountList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshApiSmsApiaccountList() {
                this.resetApiSmsApiaccountList();
                this.getApiSmsApiaccountList();
            },
            getApiSmsApiaccountList(query = {}) {
                this.loading = true;
                get(`/biz/apismsapiaccount/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.apiSmsApiaccountList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getApiSmsApiaccountById() {
                get(`/biz/apismsapiaccount/get`,{ id: this.currentApiSmsApiaccountId }).then((res) =>{
                    if(res.success){
                      this.apiSmsApiaccount = { ...this.apiSmsApiaccount, ...res.apiSmsApiaccount };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportApiSmsApiaccountList() {
                //this.btnLoading = true;
                exprotExcel(`/biz/apismsapiaccount/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/biz/apismsapiaccount/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/biz/apismsapiaccount/importData`,formData);
              this.refreshApiSmsApiaccountList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getApiSmsApiaccountList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getApiSmsApiaccountList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>